import { FACET_WS } from "./facet-workspace-theme";
import { facetViewJsonTabClass, FACET_VIEW_JSON_TABLIST_CLASS } from "../../tars-charts/FacetViewJsonToggle";

export type FacetResultDataSource = "facet" | "normalized";

type Props = {
  value: FacetResultDataSource;
  onChange: (source: FacetResultDataSource) => void;
};

export default function FacetResultSourceToggle({ value, onChange }: Props) {
  const tabClass = (active: boolean) => facetViewJsonTabClass(active);

  return (
    <div
      className={FACET_VIEW_JSON_TABLIST_CLASS}
      style={{ background: FACET_WS.segmentTrack }}
      role="tablist"
      aria-label="Result data source"
    >
      <button
        type="button"
        role="tab"
        aria-selected={value === "facet"}
        onClick={() => onChange("facet")}
        className={tabClass(value === "facet")}
      >
        Facet Result
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === "normalized"}
        onClick={() => onChange("normalized")}
        className={tabClass(value === "normalized")}
      >
        Normalized Result
      </button>
    </div>
  );
}
